import Link from "@/components/Link";
import { AppRoutes } from "@/lib/routeResolver";
import CountryFlag from "@/app/(main)/components/CountryFlag";
import type { CruiseRegionMenu } from "@/lib/cruises";

/**
 * Sidebar widget listing cruise regions and their destinations — the same
 * region → destination structure as the header "Cruises" menu. Each region
 * links to `/cruises/{region}` and each destination to
 * `/cruises/{region}/{destination}`.
 */
export default function CruiseRegionsWidget({
  regions,
  title = "Cruise Destinations",
}: {
  regions: CruiseRegionMenu[];
  title?: string;
}) {
  if (!regions?.length) return null;

  return (
    <div className="widget widget_categories">
      <h3 className="widget_title">{title}</h3>
      <ul>
        {regions.map((region) => (
          <li key={region.regionId}>
            <Link
              href={AppRoutes.cruiseRegion(region.pageUrl)}
              className="fw-bold"
              title={region.regionName}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                width={22}
                src="/main/img/theme-img/business-trip.svg"
                alt=""
              />
              {region.regionName}
            </Link>
            {region.countries?.length > 0 && (
              <ul style={{ paddingLeft: 18, marginTop: 6 }}>
                {region.countries.map((country) => (
                  <li key={country.countryId}>
                    <Link
                      href={AppRoutes.cruiseDestination(
                        region.pageUrl,
                        country.pageUrl,
                      )}
                      title={country.countryName}
                    >
                      <CountryFlag
                        country={country.countryName}
                        fallback={null}
                      />
                      {country.countryName}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
